import {FC, RefObject} from 'react';
import {Box, Button, Center, Flex, Stack} from '@chakra-ui/react';
import {api, IMemoryNote, useT} from '@kcast-fe/core';
import {Loader, useScreenSize, Svg} from 'ui-kit';

import {NoteItem} from './components';

interface IProps {
  containerRef: RefObject<HTMLDivElement | null>;
  onOpenCreate: () => void;
  onOpenEdit: (note: IMemoryNote) => void;
}

const NotesListTabFC: FC<IProps> = ({containerRef, onOpenCreate, onOpenEdit}) => {
  const {data: notes = [], isLoading} = api.memoryNotes.useMemoryNotesQuery();
  const {data: settings} = api.settings.useSettingsQuery();

  const {isLessThan768} = useScreenSize();
  const {t} = useT();

  return (
    <Stack h={'100%'} gap={'0'}>
      <Box flex={'1 1 auto'} overflowY={'auto'} p={isLessThan768 ? '0 8px' : '0 24px'}>
        {isLoading && (
          <Center h={'100%'}>
            <Loader size={'lg'} />
          </Center>
        )}

        {!isLoading && notes.length === 0 && (
          <Center
            flexDirection={'column'}
            gap={'24px'}
            h={'100%'}
            textAlign={'center'}
            p={'0 24px'}
          >
            <Box fontWeight={'500'} color={'{colors.textPrimary}'}>
              {t('notes.list.empty')}
            </Box>
            <Box color={'{colors.textSecondary}'} maxW={'400px'}>
              {t('notes.list.emptyDescription', {name: settings?.assistant?.name})}
            </Box>
            <Button size={'lg'} variant={'solid'} onClick={onOpenCreate}>
              {t('notes.newNote')}
            </Button>
          </Center>
        )}

        {!isLoading && (
          <Box px={'6px'}>
            {notes.map((note) => (
              <NoteItem key={note.id} note={note} containerRef={containerRef} onEdit={onOpenEdit} />
            ))}
          </Box>
        )}
      </Box>

      {notes.length > 0 && (
        <Flex
          p={isLessThan768 ? '12px 12px 8px 12px' : '12px 24px 8px 24px'}
          justifyContent={'flex-start'}
        >
          <Flex
            gap={'6px'}
            alignItems={'center'}
            color={'{colors.textLink}'}
            cursor={'pointer'}
            onClick={onOpenCreate}
          >
            <Svg name={'Plus'} size={'s24'} />
            <Box>{t('notes.newNote')}</Box>
          </Flex>
        </Flex>
      )}
    </Stack>
  );
};

export const NotesListTab = NotesListTabFC;
